import { Box, ButtonBase, Dialog, DialogContent, Grid, Tooltip, Typography, useMediaQuery } from '@mui/material';
import WhiteInosio from '../../../icons/whiteinosio.svg';
import BankAccountStraight from '../../../icons/BankAccountStraight.svg';
import CreditCardStraight from '../../../icons/CreditCardStraight.svg';
import DebitCardStraight from '../../../icons/DebitCardStraight.svg';
import BackIcon from '../../../icons/back1.svg';
import { CreateOneTimePaymentDto, FeesDTO, PaidByEnum, PaymentRequestBalanceDto, PaymentTypeEnum } from '@inosio/payments-sdk';
import NumberFormat from 'react-number-format';
import { convertCentsToDollars } from '../../util/converters';
import { getBuildPaymentRequestOTPDto, getSelectPayOption } from '../../../pmui/paymentrequests/sagas/paymentrequestslice';
import { useDispatch } from 'react-redux';
import { UNREG_DEBIT_CARD_GENERIC } from '../../../utils/constants';
import HelpIcon from '@mui/icons-material/Help';

interface PayMethodTypeModalProps {
  open: boolean;
  onClickCardIcon: () => void;
  onClickBankIcon: () => void;
  onBackClick: () => void;
  PaymentRequestFees: FeesDTO[];
  PaymentRequestDetails: PaymentRequestBalanceDto | null;
}
const PayMethodTypeModal = (props: PayMethodTypeModalProps) => {
  const { open, onClickCardIcon, onClickBankIcon, onBackClick, PaymentRequestFees, PaymentRequestDetails } = props;
  const cc_fee = PaymentRequestFees?.find(f=>f.PaymentType === PaymentTypeEnum.Cc);
  const isOnMobileScreen = useMediaQuery('(max-width:600px)');
  const dispatch = useDispatch();

  const style = {
    height: isOnMobileScreen ? '100%' : '523px',
  };
  return (
    <Dialog
      open={open}
      fullScreen={isOnMobileScreen}
      BackdropProps={{
        invisible: true,
      }}
      fullWidth={true}
      disableEnforceFocus
      style={{
        background: 'none',
      }}
      PaperProps={{
        style: {
          pointerEvents: 'auto',
          borderRadius: isOnMobileScreen ? '0px' : '24px',
          width: isOnMobileScreen ? '100%' : '472px',
          boxShadow: 'none',
          overflow: 'hidden',
        },
      }}
      disableEscapeKeyDown={true}
    >
      <DialogContent>
        <Box sx={style}>
          <Grid container display="flex" flexDirection="column">
            {isOnMobileScreen ? (
              <Grid item display="flex" justifyContent="center">
                <Grid item display="flex" pl={4} sx={{ width: '340px' }}>
                  <img src={WhiteInosio} style={{ width: '75px', height: '75px' }} alt="logo" />
                  <Typography
                    sx={{
                      fontFamily: 'Work Sans',
                      fontStyle: 'normal',
                      fontWeight: 700,
                      fontSize: '18px',
                      lineHeight: '23px',
                      color: '#14142B',
                      textAlign: 'left',
                      padding: '15px',
                    }}
                  >
                    {PaymentRequestDetails?.CompanyName}
                  </Typography>
                </Grid>
              </Grid>
            ) : (
              <></>
            )}
            <Typography
              id="paymentType"
              sx={{
                fontFamily: 'Work Sans',
                fontStyle: 'normal',
                fontWeight: 700,
                fontSize: '18px',
                lineHeight: '23px',
                color: '#14142B',
                display: 'flex',
                justifyContent: 'center',
                marginTop: '20px',
              }}
            >
              Payment Method Type
            </Typography>
            <Grid container rowSpacing={4} mt={4}>              
              {PaymentRequestFees &&
                PaymentRequestFees.filter((payoption) => payoption.PaymentClass === 'OTP').map((option, i, row) => {
                  return (
                    <Grid item sm={i + 1 === row.length || row.length < 3 ? 12 : 6} xs={12} key={option.PaymentType} sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <ButtonBase
                        onClick={() => {
                          option.PaymentType === 'ACH' ? onClickBankIcon() : onClickCardIcon();
                          dispatch({
                            type: getBuildPaymentRequestOTPDto.type,
                            payload: {
                              FeeAmount: option.PaidBy === PaidByEnum.Pm ? 0 : option.FeeAmount,
                              TotalAmount: PaymentRequestDetails?.Amount ? PaymentRequestDetails?.Amount + (option.PaidBy === PaidByEnum.Pm ? 0 : option.FeeAmount) : 0,
                            } as Partial<CreateOneTimePaymentDto>,
                          });
                          dispatch({
                            type: getSelectPayOption.type,
                            payload: option.PaymentType,
                          });
                        }}
                      >
                        <img id={option.PaymentType === 'CC' ? 'credit-Card-Id' : option.PaymentType === 'DB' ? 'debit-Card-Id' : 'bank-Account-Id'} src={option.PaymentType === 'CC' ? CreditCardStraight : option.PaymentType === 'DB' ? DebitCardStraight : BankAccountStraight} alt="paytype" />
                      </ButtonBase>
                      {option?.PaidBy === PaidByEnum.Pm ? (
                        <Typography>Free</Typography>
                      ) : (
                        <Grid item display="flex" alignItems="center">
                          <Typography>
                            fee
                            {option.PaymentType === 'DB' && (
                              <Tooltip leaveTouchDelay={5000} enterTouchDelay={0} title={UNREG_DEBIT_CARD_GENERIC} placement="bottom">
                                <HelpIcon sx={{ fontSize: 17, color: '#C4C4C4', cursor: 'pointer' }} />
                              </Tooltip>
                            )}
                            :&nbsp;
                          </Typography>
                          <NumberFormat thousandsGroupStyle="thousand" value={convertCentsToDollars(option?.FeeAmount ? option?.FeeAmount : 0)} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} />
                          {option.PaymentType === 'DB' && cc_fee && (<>&nbsp; - &nbsp;<NumberFormat thousandsGroupStyle="thousand" value={convertCentsToDollars(cc_fee.FeeAmount)} prefix="$" decimalSeparator="." displayType="text" type="text" thousandSeparator={true} allowNegative={true} decimalScale={2} fixedDecimalScale={true} /></>)}
                        </Grid>
                      )}
                    </Grid>
                  );
                })}
            </Grid>
          </Grid>
        </Box>
        <Grid item sx={{ position: 'absolute', top: isOnMobileScreen ? 115 : 40, left: 15 }}>
          <img src={BackIcon} alt="back" style={{ cursor: 'pointer' }} onClick={onBackClick} />
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default PayMethodTypeModal;
